import { render } from "./SignUpReportFailureModal.vue?vue&type=template&id=342efca1&ts=true"
import script from "./SignUpReportFailureModal.vue?vue&type=script&lang=ts"
export * from "./SignUpReportFailureModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__